import React from 'react';
// ---------------------------------------------------------------------------
// AchievementsSection — public barrel (re-export only)
//
// The achievements presentation layer now lives in a scalable module under
// `./achievements/`, mirroring the `mascot/avatar/` split. This file is a thin
// re-export barrel so the existing ~9 consumers (CollectionPage, Sidebar,
// MobileNav, AchievementCeremony, AchievementUnlockModal, useAchievementCount,
// AchievementCategoryGroup, ProgressPage, LevelUpCardReveal) keep importing
// from this exact path unchanged. Resolves MASCOT_SSOT_ARCHITECTURE_AUDIT_2026
// §4.2 / point 10 (the last Djay-chain god-file).
//
// Achievement data + types remain the canonical SSOT in the mascot domain
// (`mascot/achievements/achievementData.ts`) — they are re-exported here, NOT
// moved, which keeps the DDD boundary intact (no inverted dependency where the
// mascot domain imports a UI component). See DJAY_MASCOT_DOMAIN_2026 §3.7.
// ---------------------------------------------------------------------------
// Re-exported VALUES from the mascot-domain SSOT.
export { ACHIEVEMENTS, CATEGORY_LABELS, RARITY_CONFIG } from '../../mascot/achievements/achievementData';
// Re-exported TYPES from the mascot-domain SSOT.
export type { Achievement, AchievementRarity, AchievementCheckData } from '../../mascot/achievements/achievementData';
// Re-exported presentation components + types from the achievements module.
export { SparkleParticles, GoldenShimmer, LegendaryGlow, RarityDjayWrapper, CompactAchievementCard, AchievementCard, CollectibleAchievementCard, AchievementsSection } from './achievements';
export type { AchievementCardProps } from './achievements';